import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";




function WebsiteMaintainence() {
  return (
    <>
      <Helmet>
        <title>WebsiteSEO</title>
        <meta name="description" content={"Website SEO"} />
        <meta name="keywords" content={"Website SEO  "} />
      </Helmet>

<div>
  {/* HEADER
		============================================= */}
  {/* END HEADER */}
  {/* HERO
		============================================= */}
  <div className="inner-page-banner-wrap" style={{backgroundImage: 'url(/legacy/images/img/inner-banner-bg.jpg)', backgroundSize: 'cover', backgroundAttachment: 'fixed'}}>
    <div className="container">
      <h3>Website Maintainence</h3>
      <ul>
        <li><Link to="/">Home</Link></li>
        <li>Website Maintainence</li>
      </ul>
    </div>
  </div>
  <section className="gr--ghost ct-01 inner-page-hero content-section division">
    <div className="container">
      {/* CONTENT WRAPPER */}
      <div className="row d-flex align-items-center">
        {/* TEXT BLOCK */}
        <div className="col-lg-6">
          <div className="txt-block left-column wow animate__ animate__fadeInRight animated" style={{visibility: 'visible', animationName: 'fadeInRight'}}>
            {/* Module Subtitle */}
            <span className="module-subtitle"> Website Maintainence</span>
            {/* Title */}
            <h1 className="fs-28 mb-3">Efficient Website Maintenance at WebsiteSEO.ae</h1>
            {/* Text */}
            <p>A beautifully crafted website is a great business asset, but maintaining it and running it smoothly is a continuous process. At WebsiteSEO.ae, we realize that website maintenance is not only about solving problems—it's about continuously optimizing performance, security, and user experience. Our team of specialists is committed to keeping your website up and running at all times, secure, and functional.</p>
            {/* Title */}
            <h5 className="mb-2">Why Website Maintenance is Important</h5>
            <p>An abandoned website can result in broken links, slow page loading, stale content, and security risks—all of which can send potential customers packing. Our all-encompassing website maintenance solutions keep your site in top form, delivering a great user experience while also enhancing your SEO positions.</p>
          </div>
        </div>	{/* END TEXT BLOCK */}
        {/* IMAGE BLOCK */}
        <div className="col-lg-6">
          <div className="psn-rlv">
            <div className="img-block right-column wow animate__ animate__fadeInLeft animated lft-p" style={{visibility: 'visible', animationName: 'fadeInLeft'}}>
              <img className="img-fluid lt-img  bdr-r" src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/9bc9c4bc-3f82-4e46-c61c-2d9001653200/w=1920,sharpen=1" alt="content-image" />
              <img className="img-fluid  psn-sm-imgs up-down" src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/bcf52691-03ca-410a-d595-6b767904cd00/w=1920,sharpen=1" alt="content-image" />
            </div>
          </div>
        </div>
      </div>   {/* END CONTENT WRAPPER */}
    </div>	   {/* End container */}
  </section>
  <section>
    <div className="pt-100 ct-01 content-section division" style={{backgroundColor: '#f8f8f8'}}>
      <div className="container">
        {/* CONTENT WRAPPER */}
        <div className="row d-flex ">
          {/* IMAGE BLOCK */}
          <div className="col-lg-6 order-last order-lg-2">
            <div className="psn-rlv">
              <div className="img-block right-column wow animate__ animate__fadeInLeft animated lft-p" style={{visibility: 'visible', animationName: 'fadeInLeft', margin: 0}}>
                <img className="img-fluid lt-img  bdr-r" style={{padding: 0}} src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/23ded213-b4a7-4578-110b-05f496d7cb00/w=1920,sharpen=1" alt="content-image" />
              </div>
            </div>
          </div>
          {/* TEXT BLOCK */}
          <div className="col-lg-6 order-first order-lg-2">
            <div className="txt-block right-column wow animate__ animate__fadeInLeft animated" style={{visibility: 'visible', animationName: 'fadeInLeft'}}>
              {/* Title */}
              <h4 className="fs-25 mb-2">Our Website Maintenance Services</h4>
              <p>We provide a comprehensive list of website maintenance services to keep your online reputation spotless:</p>
              {/* CONTENT BOX #1 */}
              <div className="cbox-8 ico-15">
                <div className="ico-wrap color--purple">
                  <div className="cbox-8-ico"><span className="flaticon-check" /></div>
                </div>
                <div className="cbox-8-txt">
                  <p>Daily Performance Checks: We perform regular speed tests and optimization to ensure your site loads fast and effectively.</p>
                </div>
              </div>
              {/* CONTENT BOX #1 */}
              <div className="cbox-8 ico-15">
                <div className="ico-wrap color--purple">
                  <div className="cbox-8-ico"><span className="flaticon-check" /></div>
                </div>
                <div className="cbox-8-txt">
                  <p>Bug Fixes &amp; Troubleshooting: On-the-spot fixes for damaged links, coding errors, or functionality issues to make sure your website functions flawlessly.</p>
                </div>
              </div>
              {/* CONTENT BOX #1 */}
              <div className="cbox-8 ico-15">
                <div className="ico-wrap color--purple">
                  <div className="cbox-8-ico"><span className="flaticon-check" /></div>
                </div>
                <div className="cbox-8-txt">
                  <p>Security Patches &amp; Monitoring: Regular plugin, theme, and security patch updates to secure your site against cyber attacks.</p>
                </div>
              </div>
              {/* CONTENT BOX #1 */}
              {/* CONTENT BOX #1 */}
              <div className="cbox-8 ico-15">
                <div className="ico-wrap color--purple">
                  <div className="cbox-8-ico"><span className="flaticon-check" /></div>
                </div>
                <div className="cbox-8-txt">
                  <p>SEO Optimization: We also keep tracking and optimizing your search engine rankings, so that you enjoy better positions on Google and other search engines.</p>
                </div>
              </div>
              {/* CONTENT BOX #1 */}
              {/* CONTENT BOX #1 */}
              <div className="cbox-8 ico-15">
                <div className="ico-wrap color--purple">
                  <div className="cbox-8-ico"><span className="flaticon-check" /></div>
                </div>
                <div className="cbox-8-txt">
                  <p>Content Updates: Require updating text, images, or blog entries? We make your website content up-to-date and relevant.</p>
                </div>
              </div>
              {/* CONTENT BOX #1 */}
              {/* CONTENT BOX #1 */}
              <div className="cbox-8 ico-15">
                <div className="ico-wrap color--purple">
                  <div className="cbox-8-ico"><span className="flaticon-check" /></div>
                </div>
                <div className="cbox-8-txt">
                  <p>Backup &amp; Recovery Services: We conduct regular backups to safeguard your data and facilitate quick recovery in the event of any disaster.</p>
                </div>
              </div>
              {/* CONTENT BOX #1 */}
              {/* CONTENT BOX #1 */}
              <div className="cbox-8 ico-15">
                <div className="ico-wrap color--purple">
                  <div className="cbox-8-ico"><span className="flaticon-check" /></div>
                </div>
                <div className="cbox-8-txt">
                  <p>Database Optimization: Maintenance and cleaning of your database for quick performance and smooth user experience.</p>
                </div>
              </div>
              {/* CONTENT BOX #1 */}
            </div>
          </div>	{/* END TEXT BLOCK */}
        </div>   {/* END CONTENT WRAPPER */}
      </div>	 {/* End container */}
    </div>
  </section>
  <section>
    <div className="pt-100 ct-01 content-section division pb-100 " style={{backgroundColor: '#f8f8f8'}}>
      <div className="container">
        {/* CONTENT WRAPPER */}
        <div className="row d-flex align-items-center">
          {/* TEXT BLOCK */}
          <div className="col-lg-6 order-first order-lg-2">
            <div className="txt-block right-column wow animate__ animate__fadeInLeft animated pdg-l-0" style={{visibility: 'visible', animationName: 'fadeInLeft'}}>
              {/* Title */}
              <h4 className="fs-25 mb-2">The WebsiteSEO.ae Advantage</h4>
              <p>Why are our website maintenance services unique?</p>
              {/* Text */}
              <div className="cbox-8 ico-15">
                <div className="ico-wrap color--purple">
                  <div className="cbox-8-ico"><span className="flaticon-check" /></div>
                </div>
                <div className="cbox-8-txt">
                  <p>Our Expert Team: Our experienced team members are well versed in managing a variety of platforms such as WordPress, Shopify, Magento, and custom websites.</p>
                </div>
              </div>
              <div className="cbox-8 ico-15">
                <div className="ico-wrap color--purple">
                  <div className="cbox-8-ico"><span className="flaticon-check" /></div>
                </div>
                <div className="cbox-8-txt">
                  <p>Our 24/7 Support: From a small adjustment to a major problem, our team is here 24/7 to help you.</p>
                </div>
              </div>
              <div className="cbox-8 ico-15">
                <div className="ico-wrap color--purple">
                  <div className="cbox-8-ico"><span className="flaticon-check" /></div>
                </div>
                <div className="cbox-8-txt">
                  <p>Tailored Plans: We offer tailored maintenance plans that fit your business needs so that you only pay for what you need.</p>
                </div>
              </div>
              <div className="cbox-8 ico-15">
                <div className="ico-wrap color--purple">
                  <div className="cbox-8-ico"><span className="flaticon-check" /></div>
                </div>
                <div className="cbox-8-txt">
                  <p>Quick Turnaround: We deal with urgent issues and resolve them rapidly, with minimal downtime.</p>
                </div>
              </div>
            </div>
          </div>	{/* END TEXT BLOCK */}
          {/* IMAGE BLOCK */}
          <div className="col-lg-6 order-last order-lg-2">
            <div className="psn-rlv">
              <div className="img-block right-column wow animate__ animate__fadeInLeft animated lft-p" style={{visibility: 'visible', animationName: 'fadeInLeft', margin: 0}}>
                <img className="img-fluid lt-img  bdr-r" style={{padding: 0}} src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/a5efb4b6-3c0a-400a-7a53-f84007a0e700/w=1920,sharpen=1" alt="content-image" />
              </div>
            </div>
          </div>
        </div>   {/* END CONTENT WRAPPER */}
      </div>	 {/* End container */}
    </div></section>
  {/* FOOTER
		============================================= */}
  {/* END FOOTER */}
</div>

    </>
  );
}

export default WebsiteMaintainence;
